import { render } from "./BottomActionsContainer.vue?vue&type=template&id=20dd544c&scoped=true"
import script from "./BottomActionsContainer.vue?vue&type=script&lang=js"
export * from "./BottomActionsContainer.vue?vue&type=script&lang=js"

import "./BottomActionsContainer.vue?vue&type=style&index=0&id=20dd544c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dd544c"]])

export default __exports__